'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var VisuallyHidden = styled.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-8hyzbb-0"
})(["border:0;clip:rect(.1rem,.1rem,.1rem,.1rem);height:.1rem;margin:-.1rem;overflow:hidden;padding:0;position:absolute;width:.1rem;white-space:nowrap;"]);
exports.VisuallyHidden = VisuallyHidden;